export default __webpack_public_path__ + "d03e6774fb681701a7ae87a34eebc0f3.woff";